import React, { useState } from 'react';
import { LogIn } from 'lucide-react';
import useNavPrefs from '../../hooks/useNavPrefs';
import { LANDING_OPTIONS, effectiveRole } from './navConfig';

// Settings → Profile: where the app opens after sign-in (saved per user, all devices).
export default function LandingChoice({ token, user }) {
  const { landing, setLanding, loaded } = useNavPrefs(token);
  const [msg, setMsg] = useState(null);
  const role = effectiveRole(user);
  const options = LANDING_OPTIONS.filter((o) => o.roles.includes(role));
  const change = async (e) => {
    const v = e.target.value;
    setMsg(null);
    try { await setLanding(v); setMsg({ ok: true, text: 'Saved — applies next time you sign in, on any device.' }); }
    catch (err) { setMsg({ ok: false, text: err.response?.data?.detail || 'Could not save.' }); }
  };
  return (
    <div className="mt-4 p-4 rounded-xl" style={{ background: '#0F1923', border: '1px solid #2D3748' }} data-testid="landing-choice">
      <label className="text-sm font-semibold text-white flex items-center gap-2" htmlFor="landing-choice-select"><LogIn className="w-4 h-4" style={{ color: '#1E88E5' }} /> After I sign in, open…</label>
      <select id="landing-choice-select" value={landing} onChange={change} disabled={!loaded}
        className="mt-2 w-full h-10 px-3 rounded-lg text-sm bg-[#1A2433] border border-[#2D3748] text-white" data-testid="landing-choice-select">
        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      {msg && <p className="text-xs mt-2" style={{ color: msg.ok ? '#00C896' : '#F59E0B' }} data-testid="landing-choice-msg">{msg.text}</p>}
    </div>
  );
}
